import React, { createContext } from "react";

export const ForeGroundContext = createContext(null);
